<app-global-info
  icon="mdi-cloud-lock-outline"
  [title]="'unauthorized.title' | translate"
  [description]="'unauthorized.text' | translate"
  [showButton]="true"
  [buttonText]="'unauthorized.actions.try-again' | translate"
  (clicked)="back()"
></app-global-info>
